import { Check } from "lucide-react";
import { QuoteCompareForm } from "../components/compare/QuoteCompareForm";
import { CompareAside, CompareChecks, CompareEndCTA, CompareFAQ, CompareHow, CompareWhy } from "../components/compare/CompareSections";
import { COMPARE_PATH, COMPARE_PROMISES } from "../data/compareContent";
import { buildBreadcrumbsJsonLd, buildServiceJsonLd, useSEO } from "../lib/seo";
import { pageFaqJsonLd, useFaqs } from "../lib/faqs";
import { usePageSeo } from "../lib/siteTexts";

export default function OfferteVergelijken() {
  const faqs = useFaqs(COMPARE_PATH);
  const seo = usePageSeo("vergelijken");
  useSEO({
    title: seo.title,
    description: seo.description,
    path: COMPARE_PATH,
    jsonLd: buildServiceJsonLd("Kozijnofferte vergelijken", "Vrijblijvende, persoonlijke beoordeling van bestaande offertes voor kunststof en aluminium kozijnen, schuifpuien en deuren in Zuid-Holland."),
    faqJsonLd: pageFaqJsonLd(faqs, COMPARE_PATH),
    breadcrumbs: buildBreadcrumbsJsonLd([{ label: "Home", href: "/" }, { label: "Offerte vergelijken", href: COMPARE_PATH }]),
  });
  return (
    <div data-testid="compare-page">
      <section className="bg-slate-50">
        <div className="container-tight grid gap-10 py-10 sm:py-14 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <p className="eyebrow">Offerte vergelijken · 4 korte stappen</p>
            <h1 className="mt-3 font-display text-[clamp(1.75rem,2.2vw+1rem,2.6rem)] font-bold leading-tight text-ink" data-testid="compare-title">Vergelijk uw bestaande kozijnofferte</h1>
            <p className="lead mt-4 max-w-2xl">Heeft u al een offerte voor nieuwe kozijnen, een schuifpui of een deur? Stuur hem vrijblijvend naar ons. Wij beoordelen uw offerte persoonlijk en laten u weten wat wij voor u kunnen betekenen.</p>
            <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-[14px] font-medium text-ink" data-testid="compare-promises">
              {COMPARE_PROMISES.map((t) => <li key={t} className="inline-flex items-center gap-1.5"><Check className="h-4 w-4 text-maas" aria-hidden="true" /> {t}</li>)}
            </ul>
            <div className="mt-8"><QuoteCompareForm /></div>
          </div>
          <CompareAside />
        </div>
      </section>
      <CompareChecks />
      <CompareWhy />
      <CompareHow />
      <CompareFAQ faqs={faqs} />
      <CompareEndCTA />
    </div>
  );
}
